import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';  
import {HttpClient} from '@angular/common/http';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
 blog:any={id:0,title:"Loading",content:"Loading",image:"1658236360aaa.png"};
cats:any;
latestblogs:any;
content:any;
url:any;
  constructor(public datepipe: DatePipe,private http : HttpClient,private route: ActivatedRoute,private router:Router) { 


    
  }

  ngOnInit() {
    this.url = this.router.url;
    console.log(this.router.url);
    var id = this.route.snapshot.paramMap.get('blogId');

    this.http.get('https://admin.osit.com.sa/api/blog/'+id)
    .subscribe(Response => {
 
      this.blog=Response;

      this.content=this.blog.content;
    });

    this.http.get('https://admin.osit.com.sa/api/categories')
    .subscribe(Response => {
 
     
      this.cats=Response;
    });


    this.http.get('https://admin.osit.com.sa/api/latestblogs')
    .subscribe(Response => {
 
     
      this.latestblogs=Response;
    });
  }

}
